import { IRegistration } from "../../Model/Authentication.model";
import * as UserRegistrationActionTypes from "../UserRegistration/UserRegistrationActionTypes";
import { ActionWithPayload } from "@model/Store.model";

const USER_AUTHENTICATION_INITIAL_STATE: IRegistration | null = null;

export const UserRegistrationReducer = (
  state: IRegistration | null = USER_AUTHENTICATION_INITIAL_STATE,
  action: ActionWithPayload<IRegistration>
): IRegistration | null => {
  console.log("Reducer");
  console.log(action.payload);

  switch (action.type) {
    case UserRegistrationActionTypes.VERIFY_USER:
      return action.payload ?? null;
    default:
      return state;
  }
};
